module.exports = __webpack_public_path__ + "static/media/announcement.1d71ee71.svg";